// TODO - Do we need this?
export const deserialize = <TItem>(serializedItem: string): TItem | null => {
    let deserialized = null;
    try {
        deserialized = JSON.parse(serializedItem) as TItem;
    } catch (error) {
        console.info(error);
    }
    return deserialized;
};
